import React, { useState, useEffect, useContext } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "./Map.css";
import { Icon } from "leaflet";
import AppContext from "../../../context/app-context";

const redIcon = new Icon({
    iconUrl: "/red.png",
    iconSize: [30, 30]
})

const greenIcon = new Icon({
    iconUrl: "/green.png",
    iconSize: [30, 30]
})

const orangeIcon = new Icon({
    iconUrl: "/orange.png",
    iconSize: [30, 30]
})

function MapDriver(props) {
    const { addressData } = useContext(AppContext);

    const getIconForRow = (row) => {
        const status = String(row.color || "").toLowerCase();

        if (String(row.emergency).toLowerCase() === "yes" || status.includes("red")) {
            return redIcon;
        }

        if (String(row.non_functional).toLowerCase() === "yes" || status.includes("orange")) {
            return orangeIcon;
        }

        return greenIcon;
    };

    const parseCoordinates = (value) => {
        const [lat, lng] = String(value || "").split(",");
        return {
            lat: parseFloat(lat),
            lng: parseFloat((lng || "").trim()),
        };
    };

    return (
        <MapContainer center={[28.628524, 77.223274]} zoom={12}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {addressData.map((row) => {
                const position = parseCoordinates(row.gps_coordinates);

                if (Number.isNaN(position.lat) || Number.isNaN(position.lng)) {
                    return null;
                }

                return (
                <Marker
                    key={row.id}
                    position={[position.lat, position.lng]}
                    icon={getIconForRow(row)}
                >
                <Popup
                     position={[position.lat, position.lng]}
                >
                    <div>
                        <h6>{row.bus_stop}</h6>
                        <p><strong>Site Code:</strong> {row.site_code}</p>
                        <p><strong>Status:</strong> {row.emergency === "yes" ? "Emergency" : row.functional === "yes" ? "Operational" : "Non-operational"}</p>
                        <p><strong>Last Call:</strong> {String(row.last_call_time || "").slice(0, 19)}</p>
                    </div>
                </Popup>
            </Marker>
                );
            })}
        </MapContainer>
    );
}

export default MapDriver;
